
  export default {
    mounted() {
      const ms = parseInt(this.el.dataset.autoclose);
      if (ms > 0) {
        this.timer = setTimeout(() => {
          this.el.style.transition = "opacity 200ms ease-in, transform 200ms ease-in";
          this.el.style.opacity = "0";
          this.el.style.transform = "translateX(1rem)";
          const key = this.el.dataset.flashKey;
          setTimeout(() => {
            if (key) this.pushEvent("lv:clear-flash", { key: key });
            this.el.remove();
          }, 200);
        }, ms);
      }
    },
    destroyed() {
      if (this.timer) clearTimeout(this.timer);
    }
  }
